import React, { useContext } from 'react'
import { Color } from '../../../Common/Color'
import BoxCard from '../../BoxPage/BoxCard'
import AppointmentCard from '../../Appointment/AppointmentCard'
import UserCard from '../../User/UserCard'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import Sider from 'antd/es/layout/Sider'
import PublicContext from '../../PublicContext'
import defineDate from './defineDate'

export default function PublicSider () {
  const navigate = useNavigate()
  const { box, appointment, isNow, params, siderTitle, siderDisabled } = useContext(PublicContext)

  const date = defineDate(isNow, params, appointment?.begin_date)

  const buttonStyle = (specialist) => {
    if ((location.href.includes('specialist') && specialist) || (!location.href.includes('specialist') && !specialist)) {
      return { color: Color.red, borderColor: Color.red }
    } else {
      return {}
    }
  }

  return (
    <Sider width='400' style={{ backgroundColor: Color.white }}>
      <div style={{ gap: '1em', display: 'flex', flexDirection: 'column' }}>
        <div className='LayoutSentence' style={{ fontSize: '20px', marginBottom: '10px', fontWeight: 'bold' }}>
          {siderTitle}
        </div>
        <div
          className='appointmentPageContainer'
          style={{
            gap: '1em',
            flex: 1,
            display: 'flex',
            flexDirection: 'horizontal',
            position: 'relative'
          }}>
          <div className="cards" style={{ gap: '1em', display: 'flex', flexDirection: 'column' }}>
            {
              !appointment && <>
                <Button onClick={() => { navigate(`/box/${box.id}`) }} style={buttonStyle(false)}>Médecins généralistes</Button>
                { box?.teleconsulting_company_name === 'Tessan' &&
                  <Button onClick={() => { navigate(`/box/${box.id}/specialist`) }} style={buttonStyle(true)}>Médecins spécialistes</Button>
                }
              </>
            }
            {date && <AppointmentCard date={date} isNow={isNow} box={box} disabled={siderDisabled} />}
            {box && <BoxCard box={box} disabled={siderDisabled} />}
            {appointment && <UserCard appointment={appointment} />}
          </div>
        </div>
      </div>
    </Sider>
  )
}
